(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairNetworkingEventController', VirtualFairNetworkingEventController);

    VirtualFairNetworkingEventController.$inject = ['VirtualFairService', 'networkingEventUsersTypes', 'virtualFairs'];

    function VirtualFairNetworkingEventController(VirtualFairService, networkingEventUsersTypes, virtualFairs) {
        var vm = this;

        vm.getByFilter     = getByFilter;
        vm.getByFilterCsv  = getByFilterCsv;
        vm.getVirtualFairs = getVirtualFairs;

        vm.networkingEventUsersTypes       = networkingEventUsersTypes;
        vm.networkingEventUserTypeSelected = 'exhibitor'; 

        vm.virtualFairSelected = '';

        vm.flag = false;


        /*PAGINATION*/
        vm.pageChanged            = pageChanged;
        vm.setPage                = setPage;
        vm.totalItems             = [];
        vm.to                     = [];
        vm.currentPage            = null;
        vm.itemsPerPage           = [];
        vm.page                   = 1;


        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function getVirtualFairs()
        {
            if(virtualFairs) {
                vm.virtualFairs = virtualFairs;
            } else {
                let query = {};
                query['has_networking_event'] = 1;
                VirtualFairService.getAll(query).then(function(response) {
                    vm.virtualFairs = response.data;
                })
            }
        }

        function getByFilter() {

            vm.flag = false;
            let query = {};
            query['virtual_fair_id'] = vm.virtualFairSelected;
            query['type'] = vm.networkingEventUserTypeSelected;
            query['page'] = vm.page;

            VirtualFairService.getNetworkingEvent(query).then(function(response) {
                vm.flag = true;
                vm.results = response.data.data;
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;

            }).catch(function(err) {
            });
        }

        function getByFilterCsv () {
            let query = {};
            query['virtual_fair_id'] = vm.virtualFairSelected;
            query['type'] = vm.networkingEventUserTypeSelected;

            VirtualFairService.getNetworkingEventCSV(query).success(function(data, status, headers, config) {
                var anchor = document.createElement('a');
                anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(data);
                anchor.target = '_blank';
                console.log()
                anchor.download = 'virtual_fair_networking_' + vm.networkingEventUserTypeSelected + '_' + vm.virtualFairSelected + '.csv';
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
            });
        }

        function activate () {
            //vm.getByFilter()
            vm.getVirtualFairs();
        }

        activate();
    }

})();